/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { isNull, isUndefined } from "lodash"
import i18n from "i18next"
import StoreService from "../services/store"
import DynamicParamsService from "../services/dynamicParams"

export default class ValidatorsUtils {
    /**
     * runValidation run tout les validateurs contenu dans schema sur la value
     * @param key nom du champ du formulaire
     * @param value valeur de ce champ a un instant T
     * @param schema configuration du schema de validation ex. {required: "text", max: "30"}
     * @return renvoie true ou "error message" si il y a une erreur / false sinon
     */
    public static runValidation(key: string, value: any, schema: any): boolean {
        const validatorKeys: Array<string> = Object.keys(schema)
        let errorFound = false
        let required = false

        if (validatorKeys?.length) {
            validatorKeys.forEach((validatorKey: string) => {
                // tant qu'on ne trouve pas d'erreur
                if (!errorFound) {
                    // execution du validateur
                    const validation = this.validate(
                        validatorKey,
                        value,
                        schema[validatorKey]
                    )
                    if (validation) errorFound = validation
                }

                if (
                    validatorKey === "required" ||
                    validatorKey === "phoneOrEmail"
                )
                    required = true
            })
        }
        // cas special si pas requis et pas renseigné
        if (!required && errorFound && !value) {
            return false
        }

        return errorFound
    }

    /**
     * getValidator renvoie la fonction du validateur en fonction de sa key
     * @param key key du validator ex. max
     * @param value valeur de ce champ a un instant T
     * @param schemaConfig contenu du schema ex. pour {required: "mon msg"} ca sera "mon msg"
     * @return renvoie true ou "error message" si il y a une erreur / false sinon
     */
    private static validate(key: any, value: any, schemaConfig: any): any {
        if (
            key === "max" &&
            typeof schemaConfig === "number" &&
            value?.length
        ) {
            return value.length <= schemaConfig ? false : i18n.t("fieldTooLong")
        }
        if (
            key === "min" &&
            typeof schemaConfig === "number" &&
            value?.length
        ) {
            return value.length >= schemaConfig
                ? false
                : i18n.t("fieldTooShort")
        }
        if (key === "required") {
            return isNull(value) ||
                isUndefined(value) ||
                value === "" ||
                value === false
                ? schemaConfig
                : false
        }
        if (key === "email") {
            const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (typeof value === "string" && value.match(regexEmail)) {
                return false
            }
            return schemaConfig
        }
        if (key === "decimal") {
            const regexDecimal = /^[0-9,.]*$/
            if (typeof value === "string" && value.match(regexDecimal)) {
                return false
            }
            return schemaConfig
        }
        if (key === "positive") {
            if (!isNaN(value) && !isNaN(parseFloat(value)) && value > 0) {
                return false
            }
            return schemaConfig
        }
        if (key === "matches") {
            const pattern =
                typeof schemaConfig === "object" && schemaConfig !== null
                    ? schemaConfig.value
                    : schemaConfig
            const message =
                typeof schemaConfig === "object" && schemaConfig?.message
                    ? schemaConfig.message
                    : "{{#lang.notValidField}}"
            const regexp = new RegExp(pattern)
            if (typeof value === "string" && value.match(regexp)) {
                return false
            }
            return DynamicParamsService.resolveLang(message)
        }
        if (key === "date") {
            // eslint-disable-next-line no-restricted-globals
            return isNaN(value) || !(value instanceof Date)
        }
        if (key === "phoneOrEmail") {
            const store = StoreService.getInstance()
            const email = store.local.get("email")
            const phone = store.local.get("phone")

            if (
                (isNull(email) || isUndefined(email) || email === "") &&
                (isNull(phone) || isUndefined(phone) || phone === "")
            ) {
                return i18n.t("Phone_number_or_email_required")
            }
            return false
        }
        if (key === "requiredFiles") {
            if (value?.length !== schemaConfig) {
                return schemaConfig > 1
                    ? `Merci de fournir ${schemaConfig} fichiers`
                    : "Merci de fournir au moins un fichier"
            }
            return false
        }
        return false
    }

    /**
     * Verifie si une string est au format ISODate
     * @param str string à tester
     * @returns boolean
     */
    public static isIsoDate(str: string): boolean {
        if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str))
            return false
        const d = new Date(str)
        return d.toISOString() === str
    }

    /**
     * Verifie si une string est au format date
     * @param str string à tester
     * @returns boolean
     */
    public static isDate(str: string): boolean {
        return !Number.isNaN(Date.parse(str))
    }

    /**
     * Verifie si dest un object Date
     * @param d any
     * @returns boolean
     */
    public static isValidDate(d: any): boolean {
        // eslint-disable-next-line no-restricted-globals
        return !isNaN(d) && d instanceof Date
    }
}
